import { Component, OnInit, OnDestroy } from "@angular/core";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import {ActivatedRoute, Router} from "@angular/router";
import {QuickbookService} from "src/app/_services/quickbook.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: "app-quickbook-disconnect-page",
  standalone: false,
  templateUrl: "./quickbook-disconnect-page.component.html",
  styleUrl: "./quickbook-disconnect-page.component.scss",
})
export class QuickbookDisconnectPageComponent extends SubscriptionUtil implements OnInit, OnDestroy{
  translate: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    private route: ActivatedRoute,
    private quickBookService: QuickbookService,
    private errorUtil: ErrorUtil,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {
    super();
  }

  ngOnInit() {
    this.getLanguageData();
    this.route.queryParamMap.subscribe((params) => {
      //const code: any = params.get("code");
     const realmId: any = params.get("realmId");
     //const state: any = params.get("state");
      console.log(realmId, "realmId printing..");
      //call the API only if realmId is available. (When disconnection happens from quickbook)
      if (realmId) {this.sendDataToFieldEx("", realmId, "");}
    });
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          console.log("translate", this.translate);
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  sendDataToFieldEx(code: string, realmId: string, state: string) {
    this.spinner.show();
    this.quickBookService.disconnectConnection(realmId).subscribe(
      (res) => {
        this.spinner.hide();
        console.log("res printing from quickbook disconnect connection api", res);
        if (res.status === 200 || res.status === 201) {
          console.log(res, "disconnection completed..", res);
         // const data = { isDisconnected: true };
         // window.close(); 
         //may require some redirection after disconnected..
        } else {
          this.errorUtil.setErrorMessage(
            res.status,
            "QuickBooks Disconnection failed. Please try again",
            null,
            "error",
            2000,
          );
        }
      },
      (err: any) => {
        this.spinner.hide();
        console.log("err printing from quickbook disconnect connection api", err);
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.message : null,
          err.error ? err.error.message : null,
          "error",
          2000,
        );
      },
    );
  }
}
